import React from 'react'
import PersonIcon from '@mui/icons-material/Person';
import { Box, Typography } from '@mui/material';
import useStyles from '../KaraokeStyles';

const renderPlayerHints = (assignedLyrics, isGroupMode) => {
    const players = isGroupMode
        ? [
            { key: 'playerOne', color: '#3f51b5', label: 'person 1' },
            { key: 'playerTwo', color: '#4caf50', label: 'person 2' },
            { key: 'playerThree', color: '#9c27b0', label: 'person 3' },
            { key: 'playerFour', color: '#009688', label: 'person 4' },
        ]
        : [
            { key: 'playerOne', color: '#3f51b5', label: 'person 1' },
            { key: 'playerTwo', color: '#4caf50', label: 'person 2' },
        ];

    return players
        .filter(({ key }) => (assignedLyrics[key] || []).length > 0)
        .map(({ key, color, label }) => (
            <Typography key={key} className="instructions">
                Lyrics of
                <PersonIcon fontSize="small" style={{ color, marginLeft: 5, verticalAlign: 'middle' }} />
                <span style={{ color, fontWeight: 'bold' }}>{label}</span> will be highlighted during playback
            </Typography>
        ));
};

const PreviewInstructions = ({ soloAssignedLyrics, groupAssignedLyrics }) => {
    const classes = useStyles();

    return (
        <Box textAlign="center" mb={2}>
            <Typography className={classes.commandsTitle} gutterBottom>
                Preview
            </Typography>
            <Typography className={classes.instructions} sx={{ fontWeight: 600 }}>
                Solo assignment
            </Typography>
            {renderPlayerHints(soloAssignedLyrics, false)}
            {soloAssignedLyrics.bothPlayers.length > 0 && (
                <Typography className={classes.instructions}>
                    Together lines will be highlighted in orange
                </Typography>
            )}
            <Typography className={classes.instructions} sx={{ fontWeight: 600, mt: 1 }}>
                Group assignment
            </Typography>
            {renderPlayerHints(groupAssignedLyrics, true)}
            {groupAssignedLyrics.bothPlayers.length > 0 && (
                <Typography className={classes.instructions}>
                    All-person lines will be highlighted in orange
                </Typography>
            )}
        </Box>
    )
}

export default PreviewInstructions
